import appConfig from "../utils/config";

import { uploadBase64ToS3, uploadFileToS3 } from "./aws";
import { uploadImageFiles, uploadImageString } from "./cloudinaryService";

const base64Upload = (fileName: string, imageString: string) => {
    if (appConfig.preferS3ToCloudinary) return uploadBase64ToS3(fileName, imageString);

    return uploadImageString(fileName, imageString);
};

const fileUpload = (files: File[]) => {
    if (appConfig.preferS3ToCloudinary) return uploadFileToS3(files);

    return uploadImageFiles(files);
};


export { base64Upload, fileUpload };